import {useMemo} from 'react'

/**
 * Hook to process Optimizely CMS content for PDP recommendations
 * Simply passes through CMS data - each carousel component handles its own VickyAI fetching
 *
 * @param {string} productId - Current product ID/SKU (unused, kept for API compatibility)
 * @param {Object} optimizelyData - Raw Optimizely data
 * @param {boolean} isOptimizelyLoading - Is Optimizely data loading
 * @param {Object} options - Options (unused, kept for API compatibility)
 * @returns {Object} Processed Optimizely content
 */
export const useVickyCMSInjection = (productId, optimizelyData, isOptimizelyLoading, options = {}) => {
    /**************** CMS Data Pass-through ****************/
    // Simply return CMS data - each RecommendationsCarousel component
    // will handle its own VickyAI fetching based on its AIModel prop
    const processedOptimizelyContent = useMemo(() => {
        if (!optimizelyData || isOptimizelyLoading) return null

        // Deep clone for SSR safety (prevent mutations to original data)
        return JSON.parse(JSON.stringify(optimizelyData))
    }, [optimizelyData, isOptimizelyLoading])

    return {
        processedOptimizelyContent
    }
}
